/*
 * Configurateur « Monte ton skate » (Streetart, pack skate -10 %).
 * 6 etapes : board, trucks, roues, roulements, visserie, grip. Le client choisit une piece par
 * etape, puis des accessoires facultatifs (etape 7, collection accessoires-de-skate, prix normal),
 * et ajoute tout au panier ; assets/pack-skate.js applique ensuite les codes.
 * Catalogue : /search?q=tag:<tag>&view=packskate (avec largeur d'axe des trucks), complete par les
 * collections publiques de chaque famille (l'index de recherche peut avoir du retard sur les tags).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-pack-builder]');
  if (!root) return;

  var STORAGE_KEY = 'packSkateBuilder';
  var CART_URL = (window.PackSkate && window.PackSkate.root) || '/cart';
  var STEPS = [
    { key: 'board', label: 'Board', tags: ['pack-board'], collections: ['planches-de-skate', 'skateboard'],
      title: '1. Choisis ta board', text: 'La largeur de ta board nous sert à te conseiller des trucks adaptés.' },
    { key: 'trucks', label: 'Trucks', tags: ['pack-trucks'], collections: ['trucks'],
      title: '2. Choisis tes trucks', text: '' },
    { key: 'roues', label: 'Roues', tags: ['pack-roues'], collections: ['roues-skate'],
      title: '3. Choisis tes roues', text: 'Jeu de 4 roues. Petites et dures pour le street, plus grosses et tendres pour le cruising et les sols abîmés.' },
    { key: 'roulements', label: 'Roulements', tags: ['pack-roulements'], collections: ['roulements-skate'],
      title: '4. Choisis tes roulements', text: 'Jeu de 8 roulements, de quoi équiper les 4 roues.' },
    { key: 'visserie', label: 'Visserie', tags: ['pack-visserie'], collections: ['visserie'],
      title: '5. Choisis ta visserie', text: 'Visserie 1 pouce pour un montage sans riser. Prends du 1,5 pouce si tu ajoutes des risers.' },
    { key: 'grip', label: 'Grip', tags: ['pack-grip-offert', 'pack-grip'], collections: ['grip', 'grip-de-skate'],
      title: '6. Choisis ton grip', text: 'Le grip Jessup classique est offert. Les grips à design bénéficient eux aussi de -10 %.' }
  ];

  // Etape 7 (index STEPS.length) : accessoires facultatifs, plusieurs possibles, prix normal (hors remise pack).
  // Etape 8 : recapitulatif. Les deux sont accessibles une fois les 6 pieces choisies.
  var ACC = STEPS.length;
  var ACC_STEP = { key: 'accessoires', label: 'Accessoires', collection: 'accessoires-de-skate' };
  var RECAP = STEPS.length + 1;
  function complete() { return STEPS.every(function (s) { return state.sel[s.key]; }); }

  var catalog = {};
  var state = loadState();
  var els = {
    steps: root.querySelector('[data-pb-steps]'),
    head: root.querySelector('[data-pb-step-head]'),
    grid: root.querySelector('[data-pb-grid]'),
    recap: root.querySelector('[data-pb-recap]'),
    sticky: root.querySelector('[data-pb-sticky]'),
    progress: root.querySelector('[data-pb-progress]'),
    presets: root.querySelector('[data-pb-presets]'),
    overlay: root.querySelector('[data-pb-overlay]')
  };
  // Filtres de l'etape en cours (largeur de board, marque), remis a zero a chaque changement d'etape.
  var filters = { step: -1, width: '', vendor: '' };

  // Ordinateur (>= 992px, comme le CSS) : panneau « Ton pack » a droite au lieu de la barre d'etapes.
  var desktopQuery = window.matchMedia('(min-width: 992px)');
  function isDesktop() { return desktopQuery.matches; }

  // ---------- utilitaires ----------
  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function loadState() {
    try {
      var s = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (s && s.sel) { s.acc = s.acc || {}; return s; }
    } catch (e) {}
    return { step: 0, sel: {}, acc: {} };
  }
  function saveState() {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }
  function stepIndex(key) {
    for (var i = 0; i < STEPS.length; i++) if (STEPS[i].key === key) return i;
    return -1;
  }
  function isFree(product) {
    return product && product.tags.indexOf('pack-grip-offert') >= 0;
  }
  function parseWidth(text) {
    var m = String(text || '').replace(',', '.').match(/\d+(?:\.\d+)?/g) || [];
    for (var i = 0; i < m.length; i++) {
      var n = parseFloat(m[i]);
      if (n >= 7 && n <= 10.5) return n;
    }
    return null;
  }
  function boardWidth() {
    var b = state.sel.board;
    if (!b) return null;
    return parseWidth(b.variantTitle) || parseWidth(b.title);
  }

  // Pictos des etapes (10/2026) : remplacent les vignettes grises tant que la piece n'est pas choisie.
  var ICONS = {
    board: '<svg viewBox="0 0 24 24"><rect x="8" y="2" width="8" height="20" rx="4"/><circle cx="12" cy="6" r=".8"/><circle cx="12" cy="18" r=".8"/></svg>',
    trucks: '<svg viewBox="0 0 24 24"><path d="M3 9h18M12 9v5M8 14h8"/><circle cx="4" cy="9" r="1.5"/><circle cx="20" cy="9" r="1.5"/></svg>',
    roues: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3"/></svg>',
    roulements: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><circle cx="12" cy="6" r="1"/><circle cx="12" cy="18" r="1"/><circle cx="6" cy="12" r="1"/><circle cx="18" cy="12" r="1"/></svg>',
    visserie: '<svg viewBox="0 0 24 24"><path d="M8 4h8l-1 3H9zM12 7v13M10 10h4M10 13h4M10 16h4"/></svg>',
    grip: '<svg viewBox="0 0 24 24"><rect x="5" y="3" width="14" height="18" rx="2"/><path d="M8 7h.01M12 7h.01M16 7h.01M10 10h.01M14 10h.01M8 13h.01M12 13h.01M16 13h.01M10 16h.01M14 16h.01"/></svg>',
    accessoires: '<svg viewBox="0 0 24 24"><path d="M6 18 18 6M15 6h3v3M6 15v3h3"/></svg>'
  };
  function stepIcon(key) { return '<span class="pb-icon" aria-hidden="true">' + (ICONS[key] || '') + '</span>'; }
  function widthLabel(w) { return String(w).replace('.', ',') + '"'; }
  // Le titre repete souvent la marque (« Hockey Hockey Hp... ») : on la retire, elle est deja au-dessus.
  function shortTitle(p) {
    var t = String(p.title || '');
    var v = String(p.vendor || '');
    if (v && t.toLowerCase().indexOf(v.toLowerCase() + ' ') === 0) t = t.slice(v.length + 1);
    return t;
  }
  var WIDTHS = [
    { key: 'xs', label: '7,5 à 7,9"', test: function (w) { return w < 8; } },
    { key: 's', label: '8 à 8,2"', test: function (w) { return w >= 8 && w < 8.25; } },
    { key: 'm', label: '8,25 à 8,4"', test: function (w) { return w >= 8.25 && w < 8.5; } },
    { key: 'l', label: '8,5" et +', test: function (w) { return w >= 8.5; } }
  ];
  function productWidth(p) { return parseWidth(p.variants[0] && p.variants[0].title) || parseWidth(p.title); }
  function selFrom(step, product) {
    var variant = product.variants[0];
    return { handle: product.handle, title: product.title, image: product.image, variantId: variant.id, variantTitle: variant.title,
      price: variant.price, free: isFree(product) };
  }

  // ---------- catalogue ----------
  function fetchSearch(tag, page) {
    var url = '/search?q=' + encodeURIComponent('tag:' + tag) + '&type=product&options[prefix]=none&view=packskate&page=' + page;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t); });
  }
  function searchAll(tag) {
    return fetchSearch(tag, 1).then(function (first) {
      var pages = [];
      for (var p = 2; p <= (first.pages || 1); p++) pages.push(fetchSearch(tag, p));
      return Promise.all(pages).then(function (rest) {
        return rest.reduce(function (all, d) { return all.concat(d.products || []); }, first.products || []);
      });
    }).catch(function () { return []; });
  }
  function fromCollection(handle) {
    return fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        return (d.products || []).map(function (p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          return {
            handle: p.handle, title: p.title, vendor: p.vendor, url: '/products/' + p.handle,
            image: img ? img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=360' : '',
            tags: p.tags || [],
            variants: (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
              return { id: v.id, title: v.title, price: Math.round(parseFloat(v.price) * 100), compare: 0, axle: null };
            })
          };
        });
      })
      .catch(function () { return []; });
  }
  function loadFamily(step) {
    if (catalog[step.key]) return Promise.resolve(catalog[step.key]);
    var jobs = step.tags.map(searchAll).concat(step.collections.map(fromCollection));
    return Promise.all(jobs).then(function (lists) {
      var byHandle = {};
      var order = [];
      lists.forEach(function (list, i) {
        var fromSearch = i < step.tags.length;
        list.forEach(function (p) {
          var tagged = step.tags.some(function (t) { return p.tags.indexOf(t) >= 0; });
          if (!tagged || !p.variants.length) return;
          if (!byHandle[p.handle]) { order.push(p.handle); byHandle[p.handle] = p; }
          else if (fromSearch) byHandle[p.handle] = p; // la recherche porte la largeur d'axe
        });
      });
      catalog[step.key] = splitVariants(order.map(function (h) { return byHandle[h]; }));
      return catalog[step.key];
    });
  }
  // Cartes identiques aux pages collection, donc sans selecteur de taille : un produit qui aurait
  // plusieurs variantes disponibles devient une carte par variante (taille ajoutee au titre).
  function splitVariants(list) {
    var out = [];
    list.forEach(function (p) {
      if (p.variants.length < 2) { out.push(p); return; }
      p.variants.forEach(function (v) {
        out.push({ handle: p.handle + '--' + v.id, title: p.title + ' · ' + v.title, vendor: p.vendor, url: p.url,
          image: p.image, tags: p.tags, variants: [v] });
      });
    });
    return out;
  }
  // Accessoires : toute la collection (pas de tag pack), produits disponibles seulement.
  function loadAccessories() {
    if (catalog[ACC_STEP.key]) return Promise.resolve(catalog[ACC_STEP.key]);
    return fromCollection(ACC_STEP.collection).then(function (list) {
      catalog[ACC_STEP.key] = splitVariants(list.filter(function (p) { return p.variants.length; }));
      return catalog[ACC_STEP.key];
    });
  }
  function accList() {
    return Object.keys(state.acc).map(function (h) { return state.acc[h]; });
  }

  // ---------- rendu ----------
  function renderSteps() {
    var html = '';
    STEPS.forEach(function (s, i) {
      var sel = state.sel[s.key];
      var reachable = i === 0 || STEPS.slice(0, i).every(function (p) { return state.sel[p.key]; });
      var cls = (i === state.step ? 'is-current ' : '') + (sel ? 'is-done' : '');
      // Vignette de la piece choisie (selection d'avant cette version : image retrouvee dans le catalogue).
      var img = sel && (sel.image || ((catalog[s.key] || []).filter(function (p) { return p.handle === sel.handle; })[0] || {}).image);
      var thumb = img ? '<img src="' + esc(img.replace(/([?&])width=\d+/, '$1width=120')) + '" alt="" width="40" height="40">' : stepIcon(s.key);
      html += '<li class="' + cls + '"><button type="button" data-pb-goto="' + i + '"' + (reachable ? '' : ' disabled') + '>' +
        '<span class="pack-builder__thumb" aria-hidden="true">' + thumb + '</span>' +
        '<span class="pack-builder__step-text">' + (i + 1) + '. ' + esc(s.label) + '<small>' + (sel ? esc(sel.title) : 'À choisir') + '</small></span></button></li>';
    });
    var done = complete();
    var accs = accList();
    var accThumb = accs[0] && accs[0].image ? '<img src="' + esc(accs[0].image.replace(/([?&])width=\d+/, '$1width=120')) + '" alt="" width="40" height="40">' : stepIcon('accessoires');
    html += '<li class="' + (state.step === ACC ? 'is-current ' : '') + (accs.length ? 'is-done' : '') + '"><button type="button" data-pb-goto="' + ACC + '"' + (done ? '' : ' disabled') + '>' +
      '<span class="pack-builder__thumb" aria-hidden="true">' + accThumb + '</span>' +
      '<span class="pack-builder__step-text">' + (ACC + 1) + '. ' + ACC_STEP.label + '<small>' +
      (accs.length ? accs.length + ' ajouté' + (accs.length > 1 ? 's' : '') : 'Facultatif') + '</small></span></button></li>';
    html += '<li class="pack-builder__step--recap' + (state.step === RECAP ? ' is-current' : '') + '"><button type="button" data-pb-goto="' + RECAP + '"' + (done ? '' : ' disabled') + '>' +
      '<span class="pack-builder__thumb pack-builder__thumb--recap" aria-hidden="true">' + (done ? '&#10003;' : '') + '</span>' +
      '<span class="pack-builder__step-text">' + (RECAP + 1) + '. Récap<small>' + (done ? money(totals().total) : 'À compléter') + '</small></span></button></li>';
    els.steps.innerHTML = html;
    if (els.progress) {
      var n = STEPS.filter(function (s) { return state.sel[s.key]; }).length;
      els.progress.innerHTML = '<span class="pb-progress__label">' + n + '/' + STEPS.length + ' pièces choisies</span>' +
        '<span class="pb-progress__bar"><span style="width:' + Math.round(n / STEPS.length * 100) + '%"></span></span>';
    }
  }

  function truckAdvice() {
    var w = boardWidth();
    if (!w) return 'Prends des trucks dont la largeur d\'axe est proche de la largeur de ta board.';
    return 'Ta board fait ' + w + '". Prends des trucks dont l\'axe est proche de ' + w + '" : ils sont marqués « Conseillé ».';
  }

  // Format du theme (snippets/product-get-price) : prix normal barre, puis prix pack.
  function cardPrice(product, variant) {
    var pack = isFree(product) ? 'Offert' : money(Math.round(variant.price * 0.9));
    return '<span class="price price--sale"><span>' + money(variant.price) + '</span><span>' + pack + '</span></span>';
  }

  function renderGrid() {
    var recap = state.step === RECAP;
    els.grid.classList.toggle('is-recap', recap);
    if (els.recap) els.recap.hidden = recap;
    if (recap) { renderRecapStep(); return; }
    if (state.step === ACC) { renderAccStep(); return; }
    var step = STEPS[state.step];
    if (filters.step !== state.step) filters = { step: state.step, width: '', vendor: '' };
    var autoText = state.auto && !state.sel.board ? 'Choisis ta board : on complète le reste automatiquement.' : '';
    var headBase = '<h2>' + esc(step.title) + '</h2><p>' + esc(autoText || (step.key === 'trucks' ? truckAdvice() : step.text)) + '</p>' +
      (state.step > 0 && !complete() ? '<button type="button" class="pb-auto-link" data-pb-auto>Compléter le reste automatiquement</button>' : '');
    // Catalogue deja charge (changement de filtre) : rendu immediat, sans passer par « Chargement » qui
    // faisait retrecir puis rallonger la page (saut de defilement sur iPhone, 10/2026).
    var draw = function (products) {
      if (STEPS[state.step] !== step) return;
      var all = products.slice();
      els.head.innerHTML = headBase + filtersHtml(step, all);
      var list = all.filter(function (p) {
        if (filters.vendor && p.vendor !== filters.vendor) return false;
        if (filters.width) {
          var b = WIDTHS.filter(function (x) { return x.key === filters.width; })[0];
          var pw = productWidth(p);
          if (b && (!pw || !b.test(pw))) return false;
        }
        return true;
      });
      var w = boardWidth();
      if (step.key === 'trucks' && w) {
        list.sort(function (a, b) { return axleGap(a, w) - axleGap(b, w); });
      }
      if (step.key === 'grip') {
        list.sort(function (a, b) { return (isFree(b) ? 1 : 0) - (isFree(a) ? 1 : 0); });
      }
      if (!list.length) {
        els.grid.innerHTML = '<p>' + (all.length ? 'Aucune pièce ne correspond à ces filtres.' : 'Aucune pièce disponible pour le moment dans cette catégorie.') + '</p>';
        return;
      }
      els.grid.innerHTML = list.map(function (p) { return cardHtml(step, p, w); }).join('');
    };
    if (catalog[step.key]) { draw(catalog[step.key]); return; }
    els.head.innerHTML = headBase;
    els.grid.innerHTML = '<p class="pack-builder__loading">Chargement des pièces…</p>';
    loadFamily(step).then(draw);
  }

  // Filtres (10/2026) : largeur sur l'etape board, marque des qu'il y en a plusieurs.
  function filtersHtml(step, list) {
    var html = '';
    if (step.key === 'board') {
      var chips = WIDTHS.map(function (b) {
        var n = list.filter(function (p) { var pw = productWidth(p); return pw && b.test(pw); }).length;
        if (!n) return '';
        var on = filters.width === b.key;
        return '<button type="button" class="pb-chip' + (on ? ' is-on' : '') + '" data-pb-filter-width="' + b.key + '" aria-pressed="' + on + '">' + b.label + '</button>';
      }).join('');
      if (chips) html += '<div class="pb-chips" role="group" aria-label="Largeur de board"><button type="button" class="pb-chip' + (filters.width ? '' : ' is-on') + '" data-pb-filter-width="" aria-pressed="' + !filters.width + '">Toutes</button>' + chips + '</div>';
    }
    var vendors = {};
    list.forEach(function (p) { if (p.vendor) vendors[p.vendor] = (vendors[p.vendor] || 0) + 1; });
    var names = Object.keys(vendors).sort(function (a, b) { return a.localeCompare(b, 'fr'); });
    if (names.length > 1) {
      html += '<label class="pb-select"><span class="pb-sr">Marque</span><select data-pb-filter-vendor>' +
        '<option value="">Toutes les marques</option>' +
        names.map(function (v) { return '<option value="' + esc(v) + '"' + (filters.vendor === v ? ' selected' : '') + '>' + esc(v) + ' (' + vendors[v] + ')</option>'; }).join('') +
        '</select></label>';
    }
    return html ? '<div class="pb-filters">' + html + '</div>' : '';
  }

  function axleGap(product, w) {
    var best = Infinity;
    product.variants.forEach(function (v) {
      if (typeof v.axle === 'number') best = Math.min(best, Math.abs(v.axle - w));
    });
    return best;
  }

  // Carte produit : meme balisage que snippets/product-collection.liquid (vendeur, titre, prix du theme),
  // plus le bouton du configurateur. Badge (Offert, Conseille, Choisi) a la place des etiquettes du theme.
  // Carte entierement cliquable (10/2026) : plus de bouton Choisir. Loupe pour agrandir le visuel,
  // largeur en pastille pour les boards (lien « Voir la fiche » retire a la demande, 10/2026).
  function productCard(p, v, o) {
    var img = p.image ? p.image.replace(/([?&])width=\d+/, '$1width=800') : '';
    var label = (o.selected ? 'Retirer : ' : 'Choisir : ') + p.title;
    return '<div class="pb-card product-collection' + (o.selected ? ' is-selected' : '') + '" data-pb-product="' + esc(p.handle) + '" ' + o.action +
      ' role="button" tabindex="0" aria-pressed="' + !!o.selected + '" aria-label="' + esc(o.actionLabel || label) + '">' +
      '<div class="product-collection__wrapper">' +
        '<div class="product-collection__image product-image position-relative w-100">' +
          (img ? '<div class="rimage" style="padding-top: 100%;"><img class="rimage__img rimage__img--contain" src="' + esc(img) + '" alt="' + esc(p.title) +
            '" loading="lazy" width="800" height="800"></div>' : '') +
          (o.badge ? '<span class="pb-badge' + (o.badgeSoft ? ' pb-badge--soft' : '') + '">' + o.badge + '</span>' : '') +
          (o.size ? '<span class="pb-card__size">' + o.size + '</span>' : '') +
          (o.right ? '<span class="pb-card__flag' + (o.rightPromo ? ' label label--sale' : '') + '">' + o.right + '</span>' : '') +
          (img ? '<button type="button" class="pb-card__zoom" data-pb-zoom-open aria-label="Agrandir l\'image : ' + esc(p.title) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6"/><path d="m20 20-4.5-4.5M11 8v6M8 11h6"/></svg></button>' : '') +
        '</div>' +
        '<div class="product-collection__content d-flex flex-column align-items-start mt-15">' +
          '<div class="product-collection__more-info mb-3"><span>' + esc(p.vendor) + '</span></div>' +
          '<div class="product-collection__title mb-3"><h3 class="m-0 h4">' + esc(shortTitle(p)) + '</h3></div>' +
          '<div class="product-collection__price" data-pb-price>' + o.price + '</div>' +
          (o.note ? '<p class="pb-card__note">' + o.note + '</p>' : '') +
        '</div>' +
      '</div></div>';
  }

  function cardHtml(step, p, w) {
    var sel = state.sel[step.key];
    var selected = sel && sel.handle === p.handle;
    var v = p.variants[0];
    // A gauche : etat « Choisi ». A droite (10/2026) : « Offert » en etiquette promo, ou « Conseillé » en noir
    // avec l'explication sous le prix (largeur d'axe proche de la largeur de la board).
    var right = '', rightPromo = false, note = '';
    if (isFree(p)) { right = 'Offert'; rightPromo = true; }
    else if (step.key === 'trucks' && w && axleGap(p, w) <= 0.25) {
      right = 'Conseillé';
      var axle = p.variants.filter(function (x) { return typeof x.axle === 'number'; }).sort(function (a, b) { return Math.abs(a.axle - w) - Math.abs(b.axle - w); })[0];
      note = 'Conseillé pour ta board de ' + widthLabel(w) + ' : ' + (axle ? 'axe de ' + widthLabel(axle.axle) + ', ' : '') +
        'les roues arrivent au ras de la board, ni trop dedans ni trop dehors, pour un skate stable.';
    }
    var pw = step.key === 'board' ? productWidth(p) : null;
    return productCard(p, v, {
      selected: selected, badge: selected ? 'Choisi ✓' : '', right: right, rightPromo: rightPromo, note: note, price: cardPrice(p, v),
      size: pw ? widthLabel(pw) : '', action: 'data-pb-choose', actionLabel: (selected ? 'Choisi : ' : 'Choisir : ') + p.title
    });
  }

  // Etape 7 : accessoires au prix normal, ajout / retrait de chaque produit (1 exemplaire).
  function renderAccStep() {
    var n = accList().length;
    els.head.innerHTML = '<h2>' + (ACC + 1) + '. Complète ton setup</h2><p>Facultatif : tool, entretien des roulements, nettoyage du grip. Prix normal, hors remise pack.</p>';
    els.grid.innerHTML = '<p class="pack-builder__loading">Chargement des accessoires…</p>';
    loadAccessories().then(function (products) {
      if (state.step !== ACC) return;
      var cards = products.map(accCardHtml).join('');
      els.grid.innerHTML = (cards || '<p>Aucun accessoire disponible pour le moment.</p>') +
        '<div class="pb-acc__next"><button type="button" class="btn' + (n ? ' btn--secondary' : '') + '" data-pb-goto="' + RECAP + '">' +
        (n ? 'Continuer vers le récap' : 'Passer cette étape') + '</button></div>';
    });
  }

  function accCardHtml(p) {
    var sel = state.acc[p.handle];
    var v = p.variants[0];
    return productCard(p, v, {
      selected: !!sel, badge: sel ? 'Ajouté ✓' : '', price: '<span class="price"><span>' + money(v.price) + '</span></span>',
      action: 'data-pb-acc-toggle', actionLabel: (sel ? 'Retirer : ' : 'Ajouter : ') + p.title
    });
  }

  function toggleAcc(card) {
    var handle = card.getAttribute('data-pb-product');
    if (state.acc[handle]) {
      delete state.acc[handle];
    } else {
      var product = (catalog[ACC_STEP.key] || []).filter(function (p) { return p.handle === handle; })[0];
      if (!product) return;
      var variant = product.variants[0];
      state.acc[handle] = { handle: handle, title: product.title, image: product.image, variantId: variant.id, variantTitle: variant.title, price: variant.price };
    }
    render();
  }

  // pack : prix des 6 pieces remisees ; total : pack + accessoires (prix normal).
  function totals() {
    var full = 0, pack = 0, acc = 0;
    STEPS.forEach(function (s) {
      var sel = state.sel[s.key];
      if (!sel) return;
      full += sel.price;
      pack += sel.free ? 0 : Math.round(sel.price * 0.9);
    });
    accList().forEach(function (a) { acc += a.price; });
    return { full: full + acc, pack: pack, saving: full - pack, acc: acc, total: pack + acc }; // full : prix barre, accessoires compris
  }

  // Etape 8 : toutes les pieces choisies, avec visuel, prix pack et retour a l'etape pour modifier.
  function renderRecapStep(error) {
    var t = totals();
    els.head.innerHTML = '<h2>' + (RECAP + 1) + '. Ton pack</h2><p>Vérifie tes pièces avant de les ajouter au panier.</p>';
    var lines = STEPS.map(function (s, i) {
      var sel = state.sel[s.key];
      if (!sel) return '';
      var img = sel.image || ((catalog[s.key] || []).filter(function (p) { return p.handle === sel.handle; })[0] || {}).image;
      var price = sel.free ? '<s>' + money(sel.price) + '</s> <strong>Offert</strong>' : '<s>' + money(sel.price) + '</s> <strong>' + money(Math.round(sel.price * 0.9)) + '</strong>';
      return '<div class="pb-sum__line">' +
        '<span class="pb-sum__img">' + (img ? '<img src="' + esc(img.replace(/([?&])width=\d+/, '$1width=200')) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span>' +
        '<span class="pb-sum__info"><span class="pb-sum__family">' + esc(s.label) + '</span><span class="pb-sum__title">' + esc(sel.title) + '</span>' +
        (sel.variantTitle && !/^(default title|taille unique)$/i.test(sel.variantTitle) ? '<span class="pb-sum__variant">' + esc(sel.variantTitle) + '</span>' : '') +
        '<button type="button" class="pb-sum__edit" data-pb-goto="' + i + '">Modifier</button></span>' +
        '<span class="pb-sum__price">' + price + '</span></div>';
    }).join('') + accList().map(function (a) {
      return '<div class="pb-sum__line">' +
        '<span class="pb-sum__img">' + (a.image ? '<img src="' + esc(a.image.replace(/([?&])width=\d+/, '$1width=200')) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span>' +
        '<span class="pb-sum__info"><span class="pb-sum__family">Accessoire</span><span class="pb-sum__title">' + esc(a.title) + '</span>' +
        (a.variantTitle && !/^(default title|taille unique)$/i.test(a.variantTitle) ? '<span class="pb-sum__variant">' + esc(a.variantTitle) + '</span>' : '') +
        '<button type="button" class="pb-sum__edit" data-pb-goto="' + ACC + '">Modifier</button></span>' +
        '<span class="pb-sum__price"><strong>' + money(a.price) + '</strong></span></div>';
    }).join('');
    els.grid.innerHTML = '<div class="pb-sum">' + lines +
      '<div class="pb-sum__total"><span>' + (t.acc ? 'Total pack + accessoires' : 'Total pack') + '</span><span>' + money(t.total) + '</span></div>' +
      (t.saving > 0 ? '<p class="pb-sum__saving">au lieu de <s>' + money(t.full) + '</s>, soit ' + money(t.saving) + ' d\'économie</p>' : '') +
      '<label class="pb-sum__mount"><input type="checkbox" data-pb-mount' + (state.mount ? ' checked' : '') + '>' +
        '<span><strong>Je veux que mon skate soit monté</strong> (service gratuit)<em>Board grippée et pièces montées par l\'équipe du shop.</em></span></label>' +
      '<button type="button" class="btn btn--full" data-pb-add>Ajouter mon pack au panier</button>' +
      '<button type="button" class="btn btn--full btn--secondary pb-sum__checkout" data-pb-add data-pb-checkout>Passer à l\'achat</button>' +
      (error ? '<p class="pb-recap__error">' + esc(error) + '</p>' : '') +
      '<p class="pb-recap__note" data-pb-note>' + noteText() + '</p></div>';
  }

  // Note du recap : montage demande => skate livre monte (retour d'une piece grippee impossible a l'etat neuf).
  function noteText() {
    return (state.mount
      ? 'Skate livré monté et grippé par le shop. Une fois monté, les pièces ne peuvent plus être retournées à l\'état neuf.'
      : 'Pièces livrées en pack détaché, board non grippée.') + ' Montants indicatifs : la remise exacte est calculée au panier.';
  }

  function renderRecap(error) {
    if (isDesktop()) { renderPanel(error); return; }
    var count = STEPS.filter(function (s) { return state.sel[s.key]; }).length;
    var t = totals();
    var lines = STEPS.map(function (s, i) {
      var sel = state.sel[s.key];
      if (!sel) return '<div class="pb-recap__line"><span>' + esc(s.label) + '<em>À choisir</em></span><span>–</span></div>';
      var price = sel.free ? '<strong>Offert</strong>' : money(Math.round(sel.price * 0.9));
      return '<div class="pb-recap__line"><span>' + esc(s.label) + '<em>' + esc(sel.title) +
        (sel.variantTitle && !/^(default title|taille unique)$/i.test(sel.variantTitle) ? ' · ' + esc(sel.variantTitle) : '') +
        '</em><button type="button" data-pb-goto="' + i + '">Modifier</button></span><span>' + price + '</span></div>';
    }).join('') + accList().map(function (a) {
      return '<div class="pb-recap__line"><span>Accessoire<em>' + esc(a.title) +
        '</em><button type="button" data-pb-goto="' + ACC + '">Modifier</button></span><span>' + money(a.price) + '</span></div>';
    }).join('');
    els.recap.innerHTML = '<div class="pb-sheet__head"><h2>Ton pack</h2><button type="button" class="pb-sheet__close" data-pb-sheet-close aria-label="Fermer">&times;</button></div>' + lines +
      '<div class="pb-recap__total"><span>' + (t.acc ? 'Total pack + accessoires' : 'Total pack') + '</span><span>' + money(t.total) + '</span></div>' +
      (t.saving > 0 ? '<p class="pb-recap__saving">au lieu de <s>' + money(t.full) + '</s>, soit ' + money(t.saving) + ' d\'économie</p>' : '<p class="pb-recap__saving"></p>') +
      '<button type="button" class="btn btn--full" data-pb-add' + (count < STEPS.length ? ' disabled' : '') + '>' +
      (count < STEPS.length ? 'Encore ' + (STEPS.length - count) + ' pièce' + (STEPS.length - count > 1 ? 's' : '') + ' à choisir' : 'Ajouter mon pack au panier') + '</button>' +
      (error ? '<p class="pb-recap__error">' + esc(error) + '</p>' : '') +
      '<p class="pb-recap__note">Pièces livrées en pack détaché, board non grippée. Montants indicatifs : la remise exacte est calculée au panier.</p>';
    renderSticky(true, t, count);
  }

  // Ordinateur : panneau sticky a droite qui remplace la barre d'etapes et l'etape 8. Une ligne cliquable
  // par etape (vignette, piece, prix), puis total, montage et boutons d'ajout des que le pack est complet.
  function renderPanel(error) {
    var count = STEPS.filter(function (s) { return state.sel[s.key]; }).length;
    var done = count === STEPS.length;
    var t = totals();
    function line(i, label, title, img, price, isDone, reachable) {
      var cls = 'pb-panel__line' + (i === state.step ? ' is-current' : '') + (isDone ? ' is-done' : '');
      return '<button type="button" class="' + cls + '" data-pb-goto="' + i + '"' + (reachable ? '' : ' disabled') + '>' +
        '<span class="pb-panel__thumb" aria-hidden="true">' +
          (img ? '<img src="' + esc(img.replace(/([?&])width=\d+/, '$1width=120')) + '" alt="" width="40" height="40">' : stepIcon(STEPS[i] ? STEPS[i].key : 'accessoires')) + '</span>' +
        '<span class="pb-panel__info"><span class="pb-panel__family">' + (i + 1) + '. ' + esc(label) + '</span>' +
          '<span class="pb-panel__title">' + title + '</span></span>' +
        '<span class="pb-panel__price">' + price + '</span></button>';
    }
    var lines = STEPS.map(function (s, i) {
      var sel = state.sel[s.key];
      var reachable = i === 0 || STEPS.slice(0, i).every(function (p) { return state.sel[p.key]; });
      if (!sel) return line(i, s.label, '<em>À choisir</em>', '', '', false, reachable);
      var img = sel.image || ((catalog[s.key] || []).filter(function (p) { return p.handle === sel.handle; })[0] || {}).image;
      var variant = sel.variantTitle && !/^(default title|taille unique)$/i.test(sel.variantTitle) ? ' · ' + esc(sel.variantTitle) : '';
      return line(i, s.label, esc(sel.title) + variant, img, sel.free ? 'Offert' : money(Math.round(sel.price * 0.9)), true, true);
    }).join('');
    var accs = accList();
    lines += line(ACC, ACC_STEP.label,
      accs.length ? accs.map(function (a) { return esc(a.title); }).join(', ') : '<em>Facultatif</em>',
      accs[0] && accs[0].image, accs.length ? money(t.acc) : '', accs.length > 0, done);
    var left = STEPS.length - count;
    // Total, montage et boutons dans un pied colle en bas du panneau : toujours visibles meme si la liste defile.
    els.recap.innerHTML = '<h2>Ton pack</h2><div class="pb-panel__lines">' + lines + '</div><div class="pb-panel__foot">' +
      '<div class="pb-recap__total"><span>' + (t.acc ? 'Total pack + accessoires' : 'Total pack') + '</span><span>' + money(t.total) + '</span></div>' +
      (t.saving > 0 ? '<p class="pb-recap__saving">au lieu de <s>' + money(t.full) + '</s>, soit ' + money(t.saving) + ' d\'économie</p>' : '<p class="pb-recap__saving"></p>') +
      (done ? '<label class="pb-sum__mount"><input type="checkbox" data-pb-mount' + (state.mount ? ' checked' : '') + '>' +
        '<span><strong>Je veux que mon skate soit monté</strong> (service gratuit)<em>Board grippée et pièces montées par l\'équipe du shop.</em></span></label>' : '') +
      '<button type="button" class="btn btn--full pb-panel__btn" data-pb-add' + (done ? '' : ' disabled') + '>' +
        (done ? 'Ajouter mon pack au panier' : 'Encore ' + left + ' pièce' + (left > 1 ? 's' : '') + ' à choisir') + '</button>' +
      (done ? '<button type="button" class="btn btn--full btn--secondary pb-panel__btn" data-pb-add data-pb-checkout>Passer à l\'achat</button>' : '') +
      (error ? '<p class="pb-recap__error">' + esc(error) + '</p>' : '') +
      '<p class="pb-recap__note" data-pb-note>' + noteText() + '</p></div>';
    renderSticky(false, t, count);
  }

  // Barre fixe mobile (10/2026) : toujours visible, avancement, total et economie en direct. Le bouton
  // ouvre « Ton pack » en volet, ou ajoute au panier une fois les 6 pieces choisies. Decale le chat Shopify.
  function renderSticky(show, t, count) {
    if (!els.sticky) return;
    els.sticky.hidden = !show;
    var page = root.closest('.pack-builder-page');
    if (page) page.classList.toggle('has-sticky', show);
    if (!show) closeSheet();
    if (show) {
      var full = count === STEPS.length;
      els.sticky.innerHTML = '<button type="button" class="pb-sticky__total" data-pb-sheet-open aria-label="Voir mon pack">' +
          '<span>Ton pack · ' + count + '/' + STEPS.length + '</span><strong>' + money(t.total) + '</strong>' +
          (t.saving > 0 ? '<em>-' + money(t.saving) + ' économisés</em>' : '<em>-10 % sur le setup</em>') + '</button>' +
        (full ? '<button type="button" class="btn" data-pb-add>Ajouter au panier</button>'
              : '<button type="button" class="btn btn--secondary" data-pb-sheet-open>Voir mon pack</button>');
    }
    var h = show ? els.sticky.offsetHeight : 0;
    if (h) document.documentElement.style.setProperty('--shopify-chat-activator-offset', (h + 12) + 'px');
    else document.documentElement.style.removeProperty('--shopify-chat-activator-offset');
  }

  function openSheet() {
    if (isDesktop() || !els.recap || els.recap.hidden) return;
    els.recap.classList.add('is-open');
    if (els.overlay) els.overlay.hidden = false;
    document.documentElement.classList.add('pb-sheet-lock');
  }
  function closeSheet() {
    if (!els.recap) return;
    els.recap.classList.remove('is-open');
    if (els.overlay) els.overlay.hidden = true;
    document.documentElement.classList.remove('pb-sheet-lock');
  }

  // Setup pret a rouler (10/2026) : complete les etapes vides avec les pieces les plus abordables,
  // trucks a la largeur de la board, grip offert. Tout reste modifiable ensuite.
  function autoFill() {
    var todo = STEPS.filter(function (s) { return !state.sel[s.key]; });
    return Promise.all(todo.map(loadFamily)).then(function () {
      var w = boardWidth();
      todo.forEach(function (s) {
        // Trucks : jamais un truck vendu a l'unite (« Unite X 1 », « x1 »), il en faut une paire.
        var list = (catalog[s.key] || []).filter(function (p) { return s.key !== 'trucks' || !/unit[eé]\s*x\s*1|\(\s*x\s*1\s*\)/i.test(p.title); });
        if (!list.length) return;
        list.sort(function (a, b) {
          if (s.key === 'grip' && isFree(a) !== isFree(b)) return isFree(a) ? -1 : 1;
          if (s.key === 'trucks' && w) { var d = axleGap(a, w) - axleGap(b, w); if (Math.abs(d) > 0.01) return d; }
          return a.variants[0].price - b.variants[0].price;
        });
        state.sel[s.key] = selFrom(s, list[0]);
      });
      state.auto = false;
      state.step = complete() ? (isDesktop() ? ACC : RECAP) : 0;
      render();
      els.head.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  // Packs tout prets (10/2026) : un clic remplit les 6 etapes, tout reste modifiable ensuite.
  // Regles de choix : trucks a la largeur de la board (jamais a l'unite), grip Jessup offert en priorite.
  var PRESETS = [
    { key: 'start', name: 'Pour commencer', text: 'Board 8 à 8,25", la plus polyvalente, et des pièces milieu de gamme.', order: 'mid',
      board: function (w) { return w >= 8 && w <= 8.25; } },
    { key: 'budget', name: 'Petit budget', text: 'Le setup complet le moins cher, prêt à rouler.', order: 'cheap' },
    { key: 'pro', name: 'Pack Pro', text: 'Les pièces haut de gamme de chaque étape.', order: 'premium' }
  ];
  function isUnitTruck(p) { return /unit[eé]\s*x\s*1|\(\s*x\s*1\s*\)/i.test(p.title); }
  function buildPreset(preset) {
    var sel = {};
    var byPrice = function (a, b) { var d = a.variants[0].price - b.variants[0].price; return preset.order === 'premium' ? -d : d; };
    var boards = (catalog.board || []).slice();
    if (preset.board) {
      var fit = boards.filter(function (p) { var pw = productWidth(p); return pw && preset.board(pw); });
      if (fit.length) boards = fit;
    }
    boards.sort(byPrice);
    if (!boards.length) return null;
    // 'mid' : prix median du meilleur groupe (trucks a la bonne largeur, grip offert d'abord).
    var pick = function (list, sameTier) {
      if (preset.order !== 'mid') return list[0];
      var tier = list.filter(function (p) { return sameTier(p, list[0]); });
      return tier[Math.floor((tier.length - 1) / 2)];
    };
    var board = pick(boards, function () { return true; });
    sel.board = selFrom(STEPS[0], board);
    var w = parseWidth(board.variants[0].title) || parseWidth(board.title);
    for (var i = 1; i < STEPS.length; i++) {
      var s = STEPS[i];
      var list = (catalog[s.key] || []).filter(function (p) { return s.key !== 'trucks' || !isUnitTruck(p); });
      if (!list.length) return null;
      list.sort(function (a, b) {
        if (s.key === 'grip' && isFree(a) !== isFree(b)) return isFree(a) ? -1 : 1;
        if (s.key === 'trucks' && w) {
          var ga = axleGap(a, w) <= 0.25 ? 0 : axleGap(a, w), gb = axleGap(b, w) <= 0.25 ? 0 : axleGap(b, w);
          if (ga !== gb) return ga - gb;
        }
        return byPrice(a, b);
      });
      var tierOf = function (p) {
        if (s.key === 'grip') return isFree(p) ? 0 : 1;
        if (s.key === 'trucks' && w) return axleGap(p, w) <= 0.25 ? 0 : 1;
        return 0;
      };
      sel[s.key] = selFrom(s, pick(list, function (p, first) { return tierOf(p) === tierOf(first); }));
    }
    return sel;
  }
  function presetTotals(sel) {
    var full = 0, pack = 0;
    STEPS.forEach(function (s) { full += sel[s.key].price; pack += sel[s.key].free ? 0 : Math.round(sel[s.key].price * 0.9); });
    return { full: full, pack: pack };
  }
  function renderPresets() {
    if (!els.presets) return;
    var ready = STEPS.every(function (s) { return catalog[s.key]; });
    if (!ready) { els.presets.innerHTML = ''; return; }
    var cards = PRESETS.map(function (pr) {
      var sel = buildPreset(pr);
      if (!sel) return '';
      var t = presetTotals(sel);
      var active = STEPS.every(function (s) { return state.sel[s.key] && state.sel[s.key].handle === sel[s.key].handle; });
      var thumbs = STEPS.slice(0, 3).map(function (s) {
        var img = sel[s.key].image;
        return img ? '<img src="' + esc(img.replace(/([?&])width=\d+/, '$1width=200')) + '" alt="" width="72" height="72" loading="lazy">' : '';
      }).join('');
      return '<button type="button" class="pb-preset' + (active ? ' is-active' : '') + '" data-pb-preset="' + pr.key + '" aria-pressed="' + active + '">' +
        '<span class="pb-preset__thumbs" aria-hidden="true">' + thumbs + '</span>' +
        '<span class="pb-preset__name">' + esc(pr.name) + (active ? ' ✓' : '') + '</span>' +
        '<span class="pb-preset__text">' + esc(pr.text) + '</span>' +
        '<span class="pb-preset__price"><s>' + money(t.full) + '</s> <strong>' + money(t.pack) + '</strong></span>' +
        '<span class="pb-preset__cta">' + (active ? 'Pack sélectionné' : 'Choisir ce pack') + '</span></button>';
    }).join('');
    els.presets.innerHTML = cards ? '<h2 class="pb-presets__title">Un pack tout prêt ?</h2><p class="pb-presets__lead">Un clic remplit les 6 étapes, tu peux ensuite changer chaque pièce.</p><div class="pb-presets__list">' + cards + '</div><p class="pb-presets__or">Ou compose ton skate pièce par pièce :</p>' : '';
  }
  function applyPreset(key) {
    var pr = PRESETS.filter(function (p) { return p.key === key; })[0];
    var sel = pr && buildPreset(pr);
    if (!sel) return;
    state.sel = sel;
    state.auto = false;
    state.step = isDesktop() ? ACC : RECAP;
    render();
    els.head.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function startAuto() {
    if (state.sel.board) { autoFill(); return; }
    state.auto = true;
    state.step = 0;
    render();
    els.head.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function render() {
    if (isDesktop() && state.step === RECAP) state.step = ACC; // pas d'etape 8 sur ordinateur : le panneau la remplace
    renderSteps();
    renderGrid();
    renderRecap();
    renderPresets();
    saveState();
  }

  // ---------- actions ----------
  function choose(card) {
    var step = STEPS[state.step];
    var handle = card.getAttribute('data-pb-product');
    var product = (catalog[step.key] || []).filter(function (p) { return p.handle === handle; })[0];
    if (!product) return;
    state.sel[step.key] = selFrom(step, product);
    if (state.auto && step.key === 'board') { autoFill(); return; }
    // Trouver la prochaine etape non remplie ; pack complet : etape 7 (accessoires) la premiere fois, puis le recap.
    var next = state.accSeen && !isDesktop() ? RECAP : ACC;
    for (var i = 0; i < STEPS.length; i++) {
      var k = (state.step + 1 + i) % STEPS.length;
      if (!state.sel[STEPS[k].key]) { next = k; break; }
    }
    state.step = next;
    render();
    els.head.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // checkout : apres l'ajout et l'application des codes pack, direction le paiement au lieu du panier.
  function addPack(checkout) {
    var items = STEPS.map(function (s) { return { id: state.sel[s.key].variantId, quantity: 1 }; })
      .concat(accList().map(function (a) { return { id: a.variantId, quantity: 1 }; }));
    // Les deux boutons (recap et barre mobile) passent en attente : pas de double ajout.
    root.querySelectorAll('[data-pb-add]').forEach(function (button) {
      button.disabled = true;
      button.textContent = 'Ajout en cours…';
    });
    fetch(CART_URL + '/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Ajout impossible'); });
      // Montage demande (etape 7) : attribut de commande visible dans l'admin ; vide = attribut retire.
      return fetch(CART_URL + '/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Montage du skate': state.mount ? 'Oui (service gratuit)' : '' } })
      }).then(waitForPackCodes, waitForPackCodes);
    }).then(function () {
      try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
      window.location.href = checkout ? '/checkout' : CART_URL;
    }).catch(function (err) {
      var msg = err.message + ' Vérifie la disponibilité de la pièce concernée.';
      renderRecap(msg);
      if (state.step === RECAP) renderRecapStep(msg);
    });
  }

  // Laisse a pack-skate.js le temps d'appliquer les codes avant d'ouvrir le panier.
  function waitForPackCodes() {
    var code = window.PackSkate && window.PackSkate.codePack;
    var tries = 0;
    return new Promise(function (resolve) {
      (function poll() {
        tries++;
        fetch(CART_URL + '.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (c) {
            var ok = (c.discount_codes || []).some(function (d) { return d.code.toUpperCase() === String(code).toUpperCase(); });
            if (ok || tries >= 12) resolve(); else setTimeout(poll, 700);
          })
          .catch(function () { resolve(); });
      })();
    });
  }

  // Visuel agrandi au clic, comme le plein ecran des fiches produit.
  var zoom = document.querySelector('[data-pb-zoom]');
  var zoomImg = zoom && zoom.querySelector('[data-pb-zoom-img]');
  var zoomOpener = null;
  function openZoom(img) {
    if (!zoom) return;
    zoomOpener = img;
    zoomImg.src = img.currentSrc.replace(/([?&])width=\d+/, '$1width=1400');
    zoomImg.alt = img.alt;
    zoom.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    zoom.querySelector('[data-pb-zoom-close]').focus();
  }
  function closeZoom() {
    if (!zoom || zoom.hidden) return;
    zoom.hidden = true;
    zoomImg.src = 'data:,';
    document.documentElement.style.overflow = '';
    if (zoomOpener) { var c = zoomOpener.closest('.pb-card'); (c || zoomOpener).focus(); }
  }
  if (zoom) {
    zoom.addEventListener('click', closeZoom);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-pb-auto]')) { e.preventDefault(); startAuto(); }
    if (e.target.closest('[data-pb-to-presets]') && els.presets) { e.preventDefault(); els.presets.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  root.addEventListener('click', function (e) {
    var zoomBtn = e.target.closest('[data-pb-zoom-open]');
    if (zoomBtn) { var pic = zoomBtn.closest('.pb-card').querySelector('img'); if (pic) openZoom(pic); return; }
    if (e.target.closest('[data-pb-sheet-open]')) { openSheet(); return; }
    if (e.target.closest('[data-pb-sheet-close]') || e.target.closest('[data-pb-overlay]')) { closeSheet(); return; }
    var preset = e.target.closest('[data-pb-preset]');
    if (preset) { applyPreset(preset.getAttribute('data-pb-preset')); return; }
    var chip = e.target.closest('[data-pb-filter-width]');
    if (chip) {
      // Garde la position de defilement des chips et de la page pendant le nouveau rendu.
      var row = chip.closest('.pb-chips');
      var left = row ? row.scrollLeft : 0;
      var y = window.scrollY;
      filters.width = chip.getAttribute('data-pb-filter-width');
      renderGrid();
      var newRow = root.querySelector('.pb-chips');
      if (newRow) newRow.scrollLeft = left;
      window.scrollTo(0, y);
      return;
    }
    var go = e.target.closest('[data-pb-goto]');
    if (go && !go.disabled) {
      closeSheet();
      if (state.step === ACC) state.accSeen = true;
      state.step = parseInt(go.getAttribute('data-pb-goto'), 10);
      render();
      return;
    }
    var accToggle = e.target.closest('[data-pb-acc-toggle]');
    if (accToggle) { toggleAcc(accToggle.closest('[data-pb-product]')); return; }
    var choice = e.target.closest('[data-pb-choose]');
    if (choice) { choose(choice.closest('[data-pb-product]')); return; }
    var add = e.target.closest('[data-pb-add]');
    if (add && !add.disabled) addPack(add.hasAttribute('data-pb-checkout'));
  });

  root.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.pb-card')) { e.preventDefault(); e.target.click(); }
    if (e.key === 'Escape') closeSheet();
  });

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-pb-filter-vendor]')) { filters.vendor = e.target.value; renderGrid(); return; }
    if (e.target.matches('[data-pb-mount]')) {
      state.mount = e.target.checked; saveState();
      var n = root.querySelector('[data-pb-note]'); if (n) n.textContent = noteText();
    }
  });

  // Reprise d'une selection en cours : on revient a la premiere etape non remplie.
  if (state.step > RECAP || state.step < 0 || (state.step >= ACC && !complete())) state.step = 0;
  for (var i = 0; i < STEPS.length; i++) {
    if (!state.sel[STEPS[i].key]) { state.step = Math.min(state.step, i); break; }
  }
  render();
  // Prechargement des autres etapes, puis vignettes des selections reprises.
  Promise.all(STEPS.map(loadFamily)).then(function () { renderSteps(); renderRecap(); renderPresets(); });

  // Passage ordinateur <-> mobile : panneau ou barre d'etapes + etape 8.
  var onQuery = function () { closeSheet(); render(); };
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', onQuery);
  else desktopQuery.addListener(onQuery);

  // Le header du theme redevient fixe quand on remonte : le panneau sticky se cale juste dessous.
  var ticking = false;
  function placePanel() {
    ticking = false;
    var header = document.querySelector('.header__content--sticky');
    var top = 0;
    if (header && getComputedStyle(header).position === 'fixed') top = Math.max(0, header.getBoundingClientRect().bottom);
    root.style.setProperty('--pb-panel-top', (top + 20) + 'px');
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(placePanel); }
  }, { passive: true });
  placePanel();
})();
